document.addEventListener("DOMContentLoaded", function () {
  /* ---------------------------
       Utilities
       --------------------------- */
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

  /* ---------------------------
       Cart Drawer (desktop / shared)
       --------------------------- */
  const cartIcon = $("#cart-icon-bubble");
  const drawer = $("#CartDrawer");
  const overlay = $("#CartDrawerOverlay");
  const drawerClose = $("#CartDrawerClose");

  // Function to open drawer
  function openDrawer() {
    if (!drawer || !overlay) return;
    drawer.classList.remove(
      "translate-x-full",
      "opacity-0",
      "pointer-events-none"
    );
    overlay.classList.remove("opacity-0", "pointer-events-none");
    overlay.classList.add("opacity-100", "!flex");
    document.body.classList.add("overflow-hidden");
    refreshCartDrawer();
  }

  // Open drawer (desktop/original)
  cartIcon?.addEventListener("click", openDrawer);

  function closeDrawer() {
    if (!drawer || !overlay) return;
    drawer.classList.add(
      "translate-x-full",
      "opacity-0",
      "pointer-events-none"
    );
    overlay.classList.add("opacity-0", "pointer-events-none");
    overlay.classList.remove("opacity-100", "!flex");
    document.body.classList.remove("overflow-hidden");
  }
  drawerClose?.addEventListener("click", closeDrawer);
  overlay?.addEventListener("click", closeDrawer);

  // Handle product card add to cart forms
  document.body.addEventListener("submit", function (e) {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.classList.contains("product-card-add-to-cart")) return;

    e.preventDefault();

    const formData = new FormData(form);
    const variantId = formData.get("id");
    if (!variantId) return;

    const submitButton = form.querySelector('button[type="submit"]');
    if (submitButton) {
      submitButton.disabled = true;
      submitButton.style.opacity = "0.6";
    }

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        // Refresh cart drawer
        refreshCartDrawer();
        // Open cart drawer
        openDrawer();
      })
      .catch((err) => {
        console.error("Error adding to cart:", err);
      })
      .finally(() => {
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.style.opacity = "1";
        }
      });
  });

  // AJAX quantity update
  document.body.addEventListener(
    "click",
    function (e) {
      const t = e.target;
      if (!(t instanceof Element)) return;
      const btn = t.closest(".cart-qty-btn");
      if (btn) {
        e.preventDefault();
        const key = btn.dataset.key;
        const qty = parseInt(btn.dataset.qty || "0", 10);
        if (!key || qty < 0) return;

        fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: key, quantity: qty }),
        })
          .then((res) => res.json())
          .then((cartData) => {
            refreshCartDrawer();
            // Also refresh cart page if we're on the cart page
            if (
              window.location.pathname === "/cart" ||
              window.location.pathname === "/cart/"
            ) {
              // Small delay to ensure cart state is updated on server
              setTimeout(() => {
                refreshCartPage(cartData.item_count);
              }, 100);
            }
          })
          .catch((err) => console.error("Cart update failed", err));
      }
    },
    { passive: false }
  );

  // Reload cart drawer HTML
  function refreshCartDrawer() {
    fetch("/?section_id=cart-drawer")
      .then((res) => res.text())
      .then((html) => {
        const temp = document.createElement("div");
        temp.innerHTML = html;

        const newDrawer = temp.querySelector("#CartDrawer");
        const currentDrawer = document.querySelector("#CartDrawer");
        if (newDrawer && currentDrawer) {
          currentDrawer.innerHTML = newDrawer.innerHTML;
        }

        const newBubble = temp.querySelector("#cart-icon-bubble");
        const bubble = document.querySelector("#cart-icon-bubble");
        if (newBubble && bubble) {
          bubble.innerHTML = newBubble.innerHTML;
        }

        const newBubbleMobile = temp.querySelector("#cart-icon-bubble-mobile");
        const bubbleMobile = document.querySelector("#cart-icon-bubble-mobile");
        if (newBubbleMobile && bubbleMobile) {
          bubbleMobile.innerHTML = newBubbleMobile.innerHTML;
        }

        // Re-bind close after refresh
        document
          .getElementById("CartDrawerClose")
          ?.addEventListener("click", closeDrawer);
      })
      .catch(() => {});

    fetch("/")
      .then((res) => res.text())
      .then((html) => {
        const temp = document.createElement("div");
        temp.innerHTML = html;
        const newBubble = temp.querySelector("#cart-icon-bubble");
        const bubble = document.querySelector("#cart-icon-bubble");
        if (newBubble && bubble) {
          bubble.innerHTML = newBubble.innerHTML;
        }

        const newBubbleMobile = temp.querySelector("#cart-icon-bubble-mobile");
        const bubbleMobile = document.querySelector("#cart-icon-bubble-mobile");
        if (newBubbleMobile && bubbleMobile) {
          bubbleMobile.innerHTML = newBubbleMobile.innerHTML;
        }
      });
  }

  // Reload cart page HTML
  function refreshCartPage(itemCount) {
    const cartUrl =
      (typeof routes !== "undefined" && routes.cart_url) || "/cart";
    const cartWrapperContainer = document.getElementById(
      "cart-wrapper-container"
    );
    if (!cartWrapperContainer) {
      console.error("cart-wrapper-container not found");
      return;
    }

    // Update cart-items separately (always present, even when empty)
    const cartItemsElement = document.querySelector(
      "cart-items[id='main-cart-items']"
    );
    if (cartItemsElement) {
      const itemsSectionId = cartItemsElement.dataset.id;
      if (itemsSectionId) {
        fetch(`${cartUrl}?section_id=${itemsSectionId}`)
          .then((res) => res.text())
          .then((html) => {
            const temp = document.createElement("div");
            temp.innerHTML = html;
            const newCartItems = temp.querySelector(
              "cart-items[id='main-cart-items']"
            );

            if (newCartItems && cartItemsElement) {
              // Update the entire wrapper div content (includes title, empty state, and form)
              const wrapper = cartItemsElement.querySelector("div");
              const newWrapper = newCartItems.querySelector("div");

              if (wrapper && newWrapper) {
                wrapper.innerHTML = newWrapper.innerHTML;
              }

              // Also update the is-empty class on the cart-items element
              const isEmpty = newCartItems.classList.contains("is-empty");
              cartItemsElement.classList.toggle("is-empty", isEmpty);
            }
          })
          .catch((err) => console.error("Cart items refresh failed", err));
      }
    }

    // Update cart-wrapper to get the summary block and conditionally add/remove it
    // Use itemCount parameter to determine if cart is empty, rather than relying on HTML response
    const sectionId = "cart-wrapper";
    fetch(`${cartUrl}?section_id=${sectionId}`)
      .then((res) => {
        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }
        return res.text();
      })
      .then((html) => {
        const temp = document.createElement("div");
        temp.innerHTML = html;
        const shopifySection = temp.querySelector(
          `#shopify-section-cart-wrapper`
        );

        if (!shopifySection) {
          console.error("Could not find shopify section in response");
          return;
        }

        const newContainer = shopifySection.querySelector(
          "#cart-wrapper-container"
        );
        if (!newContainer) {
          console.error("Could not find cart-wrapper-container in response");
          return;
        }

        // Find the summary block (footer) - it's the div with class containing w-[30%]
        const currentSummaryBlock = cartWrapperContainer.querySelector(
          "div.w-full.lg\\:w-\\[30\\%\\]"
        );
        const newSummaryBlock = newContainer.querySelector(
          "div.w-full.lg\\:w-\\[30\\%\\]"
        );

        // Use itemCount to determine if cart is empty, not just whether newSummaryBlock exists
        const cartIsEmpty =
          itemCount !== undefined ? itemCount === 0 : !newSummaryBlock;

        if (cartIsEmpty && currentSummaryBlock) {
          // Cart is empty, remove the footer block
          currentSummaryBlock.remove();
        } else if (!cartIsEmpty) {
          // Cart has items
          if (!currentSummaryBlock && newSummaryBlock) {
            // Footer doesn't exist, add it back
            cartWrapperContainer.appendChild(newSummaryBlock.cloneNode(true));
          } else if (currentSummaryBlock && newSummaryBlock) {
            // Both exist, update the footer content
            currentSummaryBlock.outerHTML = newSummaryBlock.outerHTML;
          }
        }

        // Also update the footer section directly to ensure price is updated
        const cartFooter = document.getElementById("main-cart-footer");
        if (cartFooter && !cartIsEmpty) {
          const footerSectionId = cartFooter.dataset.id;
          if (footerSectionId) {
            fetch(`${cartUrl}?section_id=${footerSectionId}`)
              .then((res) => res.text())
              .then((html) => {
                const temp = document.createElement("div");
                temp.innerHTML = html;
                const newFooter = temp.querySelector(`#main-cart-footer`);

                if (newFooter && cartFooter) {
                  // Update the footer content (price, totals, etc.)
                  const footerContents = cartFooter.querySelector(
                    ".cart-footer-js-contents"
                  );
                  const newFooterContents = newFooter.querySelector(
                    ".cart-footer-js-contents"
                  );

                  if (footerContents && newFooterContents) {
                    footerContents.innerHTML = newFooterContents.innerHTML;
                  }

                  // Update the is-empty class
                  const isEmpty = newFooter.classList.contains("is-empty");
                  cartFooter.classList.toggle("is-empty", isEmpty);
                }
              })
              .catch((err) => console.error("Cart footer refresh failed", err));
          }
        }
      })
      .catch((err) => {
        console.error("Cart wrapper refresh failed", err);
      });
  }

  /* ---------------------------
       Mobile UX bindings
       --------------------------- */

  // Mobile search expand/collapse
  const mobileSearchToggle = document.getElementById("MobileSearchToggle");
  const mobileSearchWrap = document.getElementById("MobileSearchWrap");
  mobileSearchToggle?.addEventListener("click", () => {
    if (!mobileSearchWrap) return;
    mobileSearchWrap.classList.toggle("open");
    const isOpen = mobileSearchWrap.classList.contains("open");
    mobileSearchToggle.setAttribute("aria-expanded", String(isOpen));
    mobileSearchWrap.setAttribute("aria-hidden", String(!isOpen));
    if (isOpen) {
      setTimeout(() => {
        const input = mobileSearchWrap.querySelector(
          'input[type="search"], input[type="text"]'
        );
        input && input.focus();
      }, 220);
    }
  });

  /**
   * Robust opener for the theme’s menu drawer on mobile.
   * Works with Dawn-like <details id="HeaderDrawer">, .menu-drawer, or custom drawers.
   */
  function openHeaderMenuDrawer() {
    // 1) Dawn / details-based drawers
    /** @type {HTMLDetailsElement | null} */
    const details = document.querySelector(
      "header-drawer details#Details-menu-drawer-container, " +
        "details#Details-menu-drawer-container, " +
        "header-drawer details.menu-drawer-container, " +
        "details.menu-drawer-container, " +
        "details#HeaderDrawer, details.menu-drawer"
    );
    if (details) {
      const builtInMenuButton =
        details.querySelector("summary") ||
        document.querySelector("header-drawer [data-menu-drawer-toggle]") ||
        document.querySelector("header-drawer button[aria-controls]");

      try {
        if (builtInMenuButton && !details.hasAttribute("open")) {
          builtInMenuButton.click();
        } else if (!builtInMenuButton && !details.hasAttribute("open")) {
          details.setAttribute("open", "");
        }

        if (!details.hasAttribute("open")) {
          const headerDrawerEl = document.querySelector("header-drawer");
          const summaryEl =
            details.querySelector("summary") ||
            builtInMenuButton ||
            headerDrawerEl?.querySelector("summary");
          details.setAttribute("open", "");
          if (
            headerDrawerEl &&
            typeof headerDrawerEl.openMenuDrawer === "function" &&
            summaryEl
          ) {
            headerDrawerEl.openMenuDrawer(summaryEl);
          }
        }
      } catch (e) {
        // no-op
      }

      const panel = details.querySelector(
        '.menu-drawer, [role="dialog"], [data-menu-drawer]'
      );
      if (panel && !panel.id) {
        panel.id = "HeaderDrawerPanel";
      }

      return true;
    }

    // 2) Fallback for fully custom implementations: add a root class
    document.documentElement.classList.add("menu-drawer-open");
    return false;
  }

  // Mobile cart opens the cart drawer
  const mobileCartBtn = document.getElementById("cart-icon-bubble-mobile");
  mobileCartBtn?.addEventListener("click", () => {
    if (!drawer || !overlay) return;
    drawer.classList.remove("translate-x-full", "pointer-events-none");
    drawer.classList.add("opacity-100");
    overlay.classList.remove("opacity-0", "pointer-events-none");
    overlay.classList.add("opacity-100", "!flex");
    document.body.classList.add("overflow-hidden");
  });

  // Function to toggle menu button icon and manage body scroll
  function toggleMenuButtonIcon(isOpen) {
    const mobileMenuBtn = document.getElementById("MobileMenuToggle");
    if (!mobileMenuBtn) return;

    const hamburgerIcon = mobileMenuBtn.querySelector(".hamburger-icon");
    const closeIcon = mobileMenuBtn.querySelector(".close-icon");
    const vatToggle = document.getElementById("vat-toggle");

    if (isOpen) {
      hamburgerIcon?.classList.add("hidden");
      closeIcon?.classList.remove("hidden");
      mobileMenuBtn.setAttribute("aria-label", "Close menu");
      vatToggle?.classList.add("hidden");
      // Prevent body scroll when drawer is open
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
      document.querySelector(".header-wrapper").style.position = "fixed";
      // search-form is hidden when drawer is open
      document.querySelectorAll(".search-form")[0].style.visibility = "hidden";
      document.querySelectorAll(".search-form")[1].style.visibility = "hidden";
    } else {
      hamburgerIcon?.classList.remove("hidden");
      closeIcon?.classList.add("hidden");
      mobileMenuBtn.setAttribute("aria-label", "Open menu");
      vatToggle?.classList.remove("hidden");
      // Restore body scroll when drawer is closed
      document.body.style.overflow = "auto";
      document.documentElement.style.overflow = "auto";
      document.querySelector(".header-wrapper").style.position = "sticky";
      // search-form is visible when drawer is closed
      document.querySelectorAll(".search-form")[0].style.visibility = "visible";
      document.querySelectorAll(".search-form")[1].style.visibility = "visible";
    }
  }

  // Observer to watch for drawer state changes
  function setupDrawerObserver() {
    const details = document.querySelector(
      "header-drawer details#Details-menu-drawer-container, " +
        "details#Details-menu-drawer-container, " +
        "header-drawer details.menu-drawer-container, " +
        "details.menu-drawer-container, " +
        "details#HeaderDrawer, details.menu-drawer"
    );

    if (details) {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (
            mutation.type === "attributes" &&
            mutation.attributeName === "open"
          ) {
            const isOpen = details.hasAttribute("open");
            toggleMenuButtonIcon(isOpen);
          }
        });
      });

      observer.observe(details, { attributes: true });

      details.addEventListener("toggle", () => {
        const isOpen = details.hasAttribute("open");
        toggleMenuButtonIcon(isOpen);
      });
    }
  }

  // Initialize drawer observer
  setupDrawerObserver();

  // Top-right breadcrumb/hamburger
  const mobileMenuBtn = document.getElementById("MobileMenuToggle");
  mobileMenuBtn?.addEventListener("click", () => {
    const details = document.querySelector(
      "header-drawer details#Details-menu-drawer-container, " +
        "details#Details-menu-drawer-container, " +
        "header-drawer details.menu-drawer-container, " +
        "details.menu-drawer-container, " +
        "details#HeaderDrawer, details.menu-drawer"
    );

    const isCurrentlyOpen = details ? details.hasAttribute("open") : false;

    if (isCurrentlyOpen) {
      if (details) {
        details.removeAttribute("open");
      }
      toggleMenuButtonIcon(false);
      mobileMenuBtn.setAttribute("aria-expanded", "false");
    } else {
      openHeaderMenuDrawer();
      toggleMenuButtonIcon(true);
      mobileMenuBtn.setAttribute("aria-expanded", "true");
    }
  });

  // Optional left-side breadcrumb icon
  const mobileBreadcrumbBtn = document.getElementById("MobileBreadcrumb");
  mobileBreadcrumbBtn?.addEventListener("click", () => {
    const opened = openHeaderMenuDrawer();
    const details = document.querySelector(
      "header-drawer details#Details-menu-drawer-container, " +
        "details#Details-menu-drawer-container, " +
        "header-drawer details.menu-drawer-container, " +
        "details.menu-drawer-container, " +
        "details#HeaderDrawer, details.menu-drawer"
    );
    mobileBreadcrumbBtn.setAttribute(
      "aria-expanded",
      details ? String(details.hasAttribute("open")) : "true"
    );
  });

  // Future-proof: generic mobile buttons
  $$('.mobile-icon-btn[data-open="menu"]').forEach((btn) => {
    if (btn.id === "MobileMenuToggle" || btn.id === "MobileBreadcrumb") return;
    btn.addEventListener("click", () => {
      const opened = openHeaderMenuDrawer();
      const details = document.querySelector(
        "header-drawer details#Details-menu-drawer-container, " +
          "details#Details-menu-drawer-container, " +
          "header-drawer details.menu-drawer-container, " +
          "details.menu-drawer-container, " +
          "details#HeaderDrawer, details.menu-drawer"
      );
      btn.setAttribute(
        "aria-expanded",
        details ? String(details.hasAttribute("open")) : "true"
      );
    });
  });

  // Prefer reduced motion
  const prefersReducedMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)"
  );
  prefersReducedMotion.addEventListener?.(
    "change",
    () => {
      if (prefersReducedMotion.matches) {
        mobileSearchWrap?.style.setProperty("transition", "none", "important");
      } else {
        mobileSearchWrap?.style.removeProperty("transition");
      }
    },
    { passive: true }
  );
  if (prefersReducedMotion.matches) {
    mobileSearchWrap?.style.setProperty("transition", "none", "important");
  }
});
